import catalog1 from './catalog1.jpg'
import catalog2 from './catalog2.jpg'
import catalog3 from './catalog3.jpg'

export { catalog1, catalog2, catalog3 }



// WEBPACK FOOTER //
// ./src/features/Hotel/containers/RoomCatalog/images/index.js